'use client'

import { SectionWrapper } from '@/components/SectionWrapper'
import SectionHeader from '@/components/ui/SectionHeader'
import MotionFadeIn from '@/components/ui/MotionFadeIn'
import { getEffectiveBackground } from '@/utilities/sectionSettings'

export interface FactItem {
  title: string
  value: string
}

export interface InlineFactsSectionProps {
  infoTagText?: string
  title?: string
  subtitle?: string
  items: FactItem[]
  background?: 'white' | 'light-gray' | 'dark'
  padding?: 'none' | 'sm' | 'md' | 'lg' | 'xl'
  settings?: any
}

export default function InlineFactsSection({
  infoTagText,
  title,
  subtitle,
  items,
  background,
  padding,
  settings,
}: InlineFactsSectionProps) {
  if (!items || items.length === 0) {
    return null
  }

  // Check if any header content is provided
  const showHeader = infoTagText || title || subtitle

  const effectiveBackground = background ?? (settings ? getEffectiveBackground(settings) : 'white')
  const effectivePadding = padding ?? (settings?.padding || 'md')

  return (
    <SectionWrapper
      settings={settings}
      background={effectiveBackground}
      padding={effectivePadding}
    >
      {showHeader && (
        <SectionHeader
          infoTagText={infoTagText || ''}
          title={title || ''}
          subtitle={subtitle}
          align="center"
        />
      )}
      <MotionFadeIn>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 items-start">
          {items.map((item, index) => (
            <div key={index} className="flex flex-col gap-2 text-center">
              <div className="title-md text-primary">{item.title}</div>
              <div className="subtitle-md text-secondary">{item.value}</div>
            </div>
          ))}
        </div>
      </MotionFadeIn>
    </SectionWrapper>
  )
}
